<template>
  <nav class="sub-navigation-bar" :aria-label="backLabel ? 'Back navigation' : 'Task location'">
    <a
      v-if="backLabel"
      href="#"
      class="sub-navigation-bar__back"
      @click.prevent="$emit('back')"
    >
      <i class="arrow left icon" aria-hidden="true"></i>{{ backLabel }}
    </a>
    <template v-else>
      <app-breadcrumbs
        :segments="segments"
        :view-mode="viewMode"
        :is-at-root="isAtRoot"
        :last-segment-is-current="!taskCode"
        :task-code="taskCode"
        @navigate-all="$emit('navigate-all')"
        @navigate-segment="$emit('navigate-segment', $event)"
      />
    </template>
  </nav>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue'

export default {
  name: 'SubNavigationBar',
  components: {
    'app-breadcrumbs': Breadcrumbs
  },
  props: {
    segments: {
      type: Array,
      default: function () { return [] }
    },
    viewMode: {
      type: String,
      default: 'browse'
    },
    isAtRoot: {
      type: Boolean,
      default: true
    },
    taskCode: {
      type: String,
      default: ''
    },
    backLabel: {
      type: String,
      default: ''
    }
  }
}
</script>
